import { connect } from 'react-redux'
import Application from '../components/Application'

const mapStateToProps = (state, props) => ({
  numberOfResults: state.product.numberOfResults,
  redirectPath: state.application.redirectPath
})

export default connect(mapStateToProps)(Application)
